
import moment from "moment";
const style = { color: "#FFF" };
export const reconciliationActionColumns = [
  {
    name: <div style={style}>Action Date</div>,
    cell: (row) => moment(row["date"]).format("DD-MM-YYYY"),
  },
  {
    name: <div style={style}>Action Type</div>,
    cell: (row) => row?.type?.name,
  },
  {
    name: <div style={style}>Status</div>,
    cell: (row) => (
      <div className='d-flex justify-content-center'>
        {row?.disbursementStatus?.name}
      </div>
    ),
  },
  {
    name: <div style={style}>Description</div>,
    cell: (row) => row["actionInfo"],
  },
];
